import Spinner from "react-bootstrap/Spinner";

function LoadingSpinner() {
  return (
    <div
      style={{ width: "200px", height: "200px" }}
      className="w-100 d-flex text-[#DC2626] justify-content-center align-items-center">
      <Spinner
        animation="border"
        style={{ width: "8rem", height: "8rem" }}
        role="status"
        className="spinner"></Spinner>
    </div>
  );
}

export default LoadingSpinner;
